import { Config } from 'types/interface';
import envConfig from '../config/env.system.json';

const config: unknown = envConfig;

export default config as Config;
